!function(name, module, context) {
	//>>excludeStart("requireTmpl", pragmas.requireTmpl);
	if (typeof window['define'] !== "undefined")
		define('hotels/session',['libs/ct_user', 'libs/ct_pers', 'vendor/cookies', 'vendor/mustache'], module)
	else
	//>>excludeEnd("requireTmpl");
		context[name] = module(CT.User, CT.Pers, Cookies, Mustache)
}('Session', function(User, Pers, Cookies, Mustache) {

	/* ================ PRIVATE ============================== */
	
	// @desc ???
	function displayLastDroppedBook(pers) {
		var dateFormat = CT.settings[CT.app].smartness.dateFormat, 
			lastDroppedBook, 
			html;

		//TODO: need to move it to right place. This is repeating in search result too - karthik

		lastDroppedBook = pers.get('last_dropped_book');
		if(lastDroppedBook){
			lastDroppedBook.tot = CT.utils.formatForCurrency(lastDroppedBook.tot);
			lastDroppedBook.shid = CT.utils.shortenID(lastDroppedBook.hid);
	
			// //pluralize
			lastDroppedBook.nr += lastDroppedBook.nr > 1 ? CT.messages.hotel.Rooms : CT.messages.hotel.Room;
			lastDroppedBook.nn += lastDroppedBook.nn > 1 ? CT.messages.hotel.Nights : CT.messages.hotel.Night;
	
			// //format dates
			lastDroppedBook.cid = moment(lastDroppedBook.cid, dateFormat).format('DD MMM');
			lastDroppedBook.cod = moment(lastDroppedBook.cod, dateFormat).format('DD MMM');
			// html = Mustache.to_html($("#LastDroppedBookTpl").html(), lastDroppedBook);
			$("#AboutToBook").html(html);			
		}
	}
	
	
	
	
	// @desc ???
	function displaySmartness(pers) {
		var crData = {}, //cancelled or refund data
			dispUpcoming = true, 
			upcomingCount = 0, 
			smartDiv = $('#Home .personalBlock'), 
			userOrFriend = 'user', 
			smartMessages = CT.messages[CT.app].smartness, 
			dateFormat = CT.settings[CT.app].smartness.dateFormat, 
			cityName, travelDay, processInDays, lastCompleted, html, daysDiff, weekDiff, justBooked, lastCancelled, lastRefund, msg, tmp

		// smartness for hotel if logged in

		//get the process in days detail from messages
		processInDays = smartMessages.processInDays.split('-');

		//last refund markup generation
		lastRefund = pers.get('last_refund_up');

		//call for assistance msg
		crData.callm = Mustache.to_html(smartMessages.callAssist, {
			customerService : CT.settings[CT.app].phoneNo.customerService
		});

		//TODO : remove second condition ( added only for demo ) - karthik
		if (!($.isEmptyObject(lastRefund)) && window.location.search.indexOf('r') != -1) {
			daysDiff = moment().diff(moment(lastRefund.rd, dateFormat), 'days');
			lastRefund.days = (parseInt(processInDays[0]) - daysDiff) + '-' + (parseInt(processInDays[1]) - daysDiff);
			crData.tit = smartMessages.refundTitle;
			crData.msg = Mustache.to_html(smartMessages.refundMsg, lastRefund);
			if (lastRefund.ramt) {
				tmp = CT.utils.formatForCurrency(lastRefund.ramt);
				crData.msg += Mustache.to_html(smartMessages.refundAmount, {
					ramt : tmp
				});
			}
			html = Mustache.to_html($('#SmartnessHotelMsgsTpl').html(), crData);
			smartDiv.append(html);

			//stop upcoming trips from getting displayed
			//dispUpcoming = false;
		}

		//last cancelled markup generation
		lastCancelled = pers.get('last_cancelled');

		//TODO : remove second condition ( added only for demo ) - karthik
		if (!($.isEmptyObject(lastCancelled)) && window.location.search.indexOf('c') != -1) {
			daysDiff = moment().diff(moment(lastCancelled.cn, dateFormat), 'days');
			lastCancelled.days = (parseInt(processInDays[0]) - daysDiff) + '-' + (parseInt(processInDays[1]) - daysDiff);
			if (lastCancelled.ramt) {
				crData.tit = smartMessages.refundTitle;
				crData.msg = Mustache.to_html(smartMessages.refundMsg, lastCancelled);
				tmp = CT.utils.formatForCurrency(lastCancelled.ramt);
				crData.msg += Mustache.to_html(smartMessages.refundAmount, {
					ramt : tmp
				});
			} else {
				crData.tit = smartMessages.cancelledTitle;
				crData.msg = Mustache.to_html(smartMessages.cancelledMsg, lastCancelled);
			}
			html = Mustache.to_html($('#SmartnessHotelMsgsTpl').html(), crData);
			smartDiv.append(html);

			//stop upcoming trips from getting displayed
			//dispUpcoming = false;
		}

		//check the count of upcoming trips
		//upcomingTrips = pers.get('upcoming_trips')[0];
		// cityName = _.keys(upcomingTrips)[0];
		// upcomingTrips = upcomingTrips[cityName];
		// upcomingCount = upcomingCount + parseInt(upcomingTrips.tc);

		//TODO : remove second condition ( added only for demo ) - karthik
		if (dispUpcoming && window.location.search.indexOf('u') != -1) {
			upcomingCount = upcomingCount - 1;
			//find out who is travelling - user or friend
			/*if(upcomingTrips.pax[0].fn.toLowerCase() == 'Sandhya'.toLowerCase() && upcomingTrips.pax[0].ln.toLowerCase() == 'Malvankar'.toLowerCase()) {
			 userOrFriend = 'friend';
			 }
			 //upcoming trips details
			 weekDiff = moment(upcomingTrips.cd, dateFormat).diff(moment().hours(0).minutes(0).seconds(0), 'weeks');
			 if(weekDiff == 0) {
			 daysDiff = moment(upcomingTrips.cd, dateFormat).diff(moment().hours(0).minutes(0).seconds(0), 'days');
			 if(daysDiff == 0) {
			 travelDay = 'tod';
			 } else if(daysDiff == 1) {
			 travelDay = 'tom';
			 } else if(daysDiff == 2) {
			 travelDay = 'dat';
			 } else {
			 travelDay = 'tw';
			 }
			 } else if(weekDiff == 1) {
			 travelDay = 'wl';
			 }

			 if(userOrFriend == 'friend') {
			 upcomingTrips.lt = Mustache.to_html(smartMessages[userOrFriend][travelDay], { fn: upcomingTrips.pax[0].fn, pn: upcomingTrips.pax[0].tl=='Mr' ? 'him':'her' });
			 } else {
			 upcomingTrips.lt = smartMessages[userOrFriend][travelDay];
			 }
			 upcomingTrips.st = smartMessages.shmsg[travelDay];

			 //change time and date formats
			 upcomingTrips.cd = moment(upcomingTrips.cd, dateFormat).format('ddd, DD MMM');
			 upcomingTrips.cit = moment(upcomingTrips.cd, dateFormat).format('hh A');
			 upcomingTrips.plc = upcomingTrips.a + ', ' + cityName;
			 if(upcomingTrips.cit == '12 PM') {
			 upcomingTrips.cit = '12 noon';
			 }

			 //smart upcoming trips display
			 html = Mustache.to_html($('#SmartnessHotelTpl').html(), upcomingTrips);
			 smartDiv.append(html);*/
		}

		//trip count display
		if (upcomingCount > 0) {
			html = Mustache.to_html($('#SmartnessHotelTcTpl').html(), {
				tc : upcomingCount
			});
		}
		smartDiv.append(html);

		//just booked display
		/* justBooked = pers.get('just_booked')[0];

		 if(!($.isEmptyObject(justBooked))) {
		 html = Mustache.to_html($('#SmartnessHotelJbTpl').html(), justBooked);
		 smartDiv.append(html);
		 }*/
	}



	function displayWelcomeBackMsg() {
		var smartDiv = $('#Home .personalBlock'), html;

		html = Mustache.to_html($('#SmartnessHotelMsgsTpl').html(), CT.messages[CT.app].smartness.notLoyalUser);
		smartDiv.append(html);
	}
	
	

	function simulateLogin(callback){
		pers.getJson('', callback);
	}

	return {
		lastDroppedBook : displayLastDroppedBook,
		welcomeBack : displayWelcomeBackMsg,
		smartness : displaySmartness,
		fakeLogin : simulateLogin // TODO 
	};

}, CT)
;
